/**
 * @param {string} baseRoute
 * @param {Object} extraParams query params as key value pairs in the object
 * @param {Boolean} appendAllExistingQueryParams
 * @param {Boolean} appendExistingUtmParams
 *
 */

export const generateUrlWithParams = (
  baseRoute,
  extraParams,
  appendAllExistingQueryParams = false,
  appendExistingUtmParams = true,
) => {
  if (typeof extraParams !== 'object') {
    extraParams = {};
  }

  let initialStr = /\?.+=.*/g.test(baseRoute) ? '&' : '?';

  if (!appendAllExistingQueryParams && !appendExistingUtmParams) {
    return baseRoute + convertParamObjToStr(extraParams, initialStr);
  }

  let paramObj = {};
  // extract utm params from location
  const existingParamsObj = convertQueryStrParamsToJson(window.location.search);

  for (let param in existingParamsObj) {
    if (appendAllExistingQueryParams) {
      paramObj[param] = existingParamsObj[param];
    } else if (appendExistingUtmParams) {
      if (/^utm_/i.test(param)) {
        paramObj[param] = existingParamsObj[param];
      }
    }
  }
  paramObj = { ...removeInvalidKeys(extraParams), ...paramObj };
  return baseRoute + convertParamObjToStr(paramObj, initialStr);
};

export const convertQueryStrParamsToJson = (query) => {
  return query
    ? (/^[?]/.test(query) ? query.slice(1) : query)
        .split('&')
        .reduce((params, param) => {
          let [key, value] = param.split('=');
          params[key] = value ? decodeURIComponent(value) : '';
          return params;
        }, {})
    : {};
};

const removeInvalidKeys = (obj) => {
  return Object.keys(obj)
    .filter((k) => obj[k] != null && obj[k] !== '') // Remove undef. and null and empty str.
    .reduce(
      (newObj, k) =>
        typeof obj[k] === 'object'
          ? { ...newObj, [k]: removeInvalidKeys(obj[k]) } // Recursive methods.
          : { ...newObj, [k]: obj[k] }, // Copy value.
      {},
    );
};

const convertParamObjToStr = (paramObj, str) => {
  const validParamObj = removeInvalidKeys(paramObj);
  const paramLength = Object.keys(validParamObj).length;

  if (paramLength) {
    let index = 0;
    for (let param in validParamObj) {
      index++;
      if (
        Array.isArray(validParamObj[param]) &&
        validParamObj[param].length === 0
      ) {
        continue;
      }
      str += `${param}=${validParamObj[param]}${
        index < paramLength ? '&' : ''
      }`;
    }
    return str;
  }
  return '';
};



// WEBPACK FOOTER //
// ./utils/routeHandler.js